<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1103001000011ogcbd.vue
*@ 컴포넌트설명 : 캄보디아 예금 상품 > 예금 상품 상세(개인정기적금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->

<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>개인정기적금</h2>
          </div>
          <div class="description">
            <p>
              매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">최대 연 </span>
              </div>
              <div class="percent">
                3.85%
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>Installment Savings Account</dd>
            <dt>상품개요</dt>
            <dd>매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품</dd>
            <dt>가입대상</dt>
            <dd>18세 이상 성인</dd>
            <dt>계약기간</dt>
            <dd>6개월~ 3년 이내에서 월단위</dd>
            <dt>가입통화</dt>
            <dd>USD</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 USD 10.00 이상 USD 10.00 단위로 예치</dd>
            <dt>금리 및 이율</dt>
            <dd></dd>
          </dl>
          <div class="info info-type4">
            <strong>약정이율</strong>
            <p>통화 : USD</p>
          </div>
          <div class="tbl-top-etc">(연이율, 세전, 단위%)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">예금이율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>6개월 ~ 12개월미만</td>
                <td>3.05</td>
              </tr>
              <tr>
                <td>1년이상 ~ 2년미만</td>
                <td>3.50</td>
              </tr>
              <tr>
                <td>2년이상 ~ 3년미만</td>
                <td>3.70</td>
              </tr>
              <tr>
                <td>3년이상</td>
                <td>3.85</td>
              </tr>
            </tbody>
          </table>
          <br />

          <div class="info info-type4">
            <strong>중도해지이율</strong>
            <p>통화 : USD</p>
          </div>
          <div class="tbl-top-etc">(연이율, 세전, 단위%)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">예금이율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1개월 ~ 6개월미만</td>
                <td>0.10</td>
              </tr>
              <tr>
                <td>6개월 ~ 12개월미만</td>
                <td>0.50</td>
              </tr>
              <tr>
                <td>1년이상 ~ 2년미만</td>
                <td>1.00</td>
              </tr>
              <tr>
                <td>2년이상 ~ 3년미만</td>
                <td>1.70</td>
              </tr>
              <tr>
                <td>3년이상</td>
                <td>2.00</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 만기이후이율 : 연+2%</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>수수료</strong>
          </div>

          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입, 인터넷 가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>ID 카드, 여권 등 실명확인증표</p>
          </div>
        </article>
      </div>
    </template>
    <!--영어-->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Personal Installment savings account</h2>
          </div>
          <div class="description">
            <p>
              An installment product to build savings by depositing a fixed amount every month
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">Maximum </span>
              </div>
              <div class="percent">
                3.85% annually
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Installment Savings Account</dd>
            <dt>About the products</dt>
            <dd>An installment product to build savings by depositing a fixed amount every month</dd>
            <dt>Eligibilty</dt>
            <dd>Adults over 18 years old</dd>
            <dt>Contract Terms</dt>
            <dd>6 months ~ 3 years on a monthly basis</dd>
            <dt>Available currency</dt>
            <dd>USD</dd>
            <dt>Deposit amount</dt>
            <dd>To open a new account, deposit a minimum of USD 10.00 (in unit of USD 10.00)</dd>
            <dt>Rates</dt>
            <dd></dd>
          </dl>
          <div class="info info-type4">
            <strong>The agreed interest rate</strong>
            <p>Currency : USD</p>
          </div>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">Savings interest rate</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>6 months ~ less than 12 months</td>
                <td>3.05</td>
              </tr>
              <tr>
                <td>More than 1 year ~ less than 2 years</td>
                <td>3.50</td>
              </tr>
              <tr>
                <td>More than 2 years ~ less than 3 years</td>
                <td>3.70</td>
              </tr>
              <tr>
                <td>More than 3 years</td>
                <td>3.85</td>
              </tr>
            </tbody>
          </table>
          <br />

          <div class="info info-type4">
            <strong>Interest rate for an early termination</strong>
            <p>Currency : USD</p>
          </div>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">Savings interest rate</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 month ~ less than 6 months</td>
                <td>0.10</td>
              </tr>
              <tr>
                <td>6 months ~ less than 12 months</td>
                <td>0.50</td>
              </tr>
              <tr>
                <td>More than 1 year ~ less than 2 years</td>
                <td>1.00</td>
              </tr>
              <tr>
                <td>More than 2 years ~ less than 3 years</td>
                <td>1.70</td>
              </tr>
              <tr>
                <td>More than 3 years</td>
                <td>2.00</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Interest rate after the maturity : +2% annually</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
          </div>

          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch, Apply Online</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>ID card, passport, identity verification, etc.</p>
          </div>
        </article>
      </div>
    </template>
    <!--캄보디아-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>គណនីសន្សំថេរ</h2>
          </div>
          <div class="description">
            <p>
              ការសន្សំប្រាក់រាល់ខែដើម្បីទទួលបានចំនួនទឹកប្រាក់ច្រើន
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">Maximum </span>
              </div>
              <div class="percent">
                3.85% annually
              </div>
            </div>
          </div>
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ប្រភេទផលិតផល</dt>
            <dd>គណនីសន្សំថេរមានកាលកំណត់</dd>
            <dt>មាតិកាផលិតផល</dt>
            <dd>ការសន្សំប្រាក់រាល់ខែដើម្បីទទួលបានចំនួនទឹកប្រាក់ច្រើន</dd>
            <dt>អតិថិជនគោលដៅ</dt>
            <dd>អ្នកដែលមានអាយុចាប់ពី១៨ឆ្នាំឡើងទៅ</dd>
            <dt>រយៈពេលកិច្ចសន្យា</dt>
            <dd>ពី៦ខែ ដល់៣ឆ្នាំ</dd>
            <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
            <dd>USD</dd>
            <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
            <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD10.00 (ឯកត្តាUSD10.00)</dd>
            <dt>អត្រាការប្រាក់</dt>
            <dd></dd>
          </dl>
          <div class="info info-type4">
            <strong>ការប្រាក់ក្នុងកិច្ចសន្យា</strong>
            <p>រូបិយវត្ថុ : USD</p>
          </div>
          <div class="tbl-top-etc">(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">រយៈពេល</th>
                <th scope="col" colspan="2">ការប្រាក់ក្នុងការបញ្ចូលប្រាក់</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ពី៦ខែ ដល់តិចជាង១ឆ្នាំ</td>
                <td>3.05</td>
              </tr>
              <tr>
                <td>ពី១ឆ្នាំ ដល់តិចជាង២ឆ្នាំ</td>
                <td>3.50</td>
              </tr>
              <tr>
                <td>ពី២ឆ្នាំ ដល់តិចជាង៣ឆ្នាំ</td>
                <td>3.70</td>
              </tr>
              <tr>
                <td>លើសពី៣ឆ្នាំ</td>
                <td>3.85</td>
              </tr>
            </tbody>
          </table>
          <br />

          <div class="info info-type4">
            <strong>ការប្រាក់នៅពេលលុបចោលការសន្សំប្រាក់នៅពាក់កណ្តាល</strong>
            <p>រូបិយវត្ថុ : USD</p>
          </div>
          <div class="tbl-top-etc">(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="1" scope="col">រយៈពេល</th>
                <th scope="col" colspan="2">ការប្រាក់ក្នុងការបញ្ចូលប្រាក់</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>ពី1ខែ ដល់តិចជាង៦ខែ</td>
                <td>0.10</td>
              </tr>
              <tr>
                <td>ពី៦ខែ ដល់តិចជាង1ឆ្នាំ</td>
                <td>0.50</td>
              </tr>
              <tr>
                <td>ពី១ឆ្នាំ ដល់តិចជាង២ឆ្នាំ</td>
                <td>1.00</td>
              </tr>
              <tr>
                <td>ពី២ឆ្នាំ ដល់តិចជាង៣ឆ្នាំ</td>
                <td>1.70</td>
              </tr>
              <tr>
                <td>លើសពី៣ឆ្នាំ</td>
                <td>2.00</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· ការប្រាក់បន្ទាប់ពីផុតកំនត់: ក្នុងមួយឆ្នាំ +2%</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>កំរៃសេវា</strong>
          </div>

          <div class="info info-type4">
            <strong>របៀបចុះឈ្មោះ</strong>
            <p>ចុះឈ្មោះនៅសាខា, ចុះឈ្មោះតាមអ៊ីនធឺណិត</p>
          </div>
          <div class="info info-type4">
            <strong>តំរូវការឯកសារចុះឈ្មោះ</strong>
            <p>កាតID លិខិតឆ្លងដែន និងលេខអត្តសញ្ញាណប័ណ្ណ</p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
